import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { AppContainer } from 'react-hot-loader'
import store from './store'
import App from './components/App'
import 'bootstrap/dist/css/bootstrap.min.css'
import { injectGlobal } from 'styled-components'
import fontsReferences from './components/common/fontsReferences'
import globalStyles from './components/common/globalStyles'
import NotificationsSystem from 'reapop'
import theme from 'reapop-theme-wybo'

injectGlobal`${fontsReferences} ${globalStyles}`

const render = Component => {
  ReactDOM.render(
    <AppContainer warnings={false}>
      <Provider store={store}>
        <div>
          <NotificationsSystem theme={theme} />
          <Component />
        </div>
      </Provider>
    </AppContainer>
    , document.getElementById('root'))
}

render(App)

if (module.hot) {
  module.hot.accept('./components/App', () => {
    render(App)
  })
}
